import React from 'react';
import { motion } from 'framer-motion';
import { Search, Cpu, FileOutput } from 'lucide-react';

const steps = [
  {
    id: 1,
    title: "Input FP/TP Number",
    description: "Simply enter the Final Plot or Town Planning scheme number to locate your land.",
    icon: Search
  },
  {
    id: 2,
    title: "Processing",
    description: "Our engine queries ownership records, overlays maps, and checks regulations simultaneously.",
    icon: Cpu
  },
  {
    id: 3,
    title: "Actionable Report",
    description: "Get a comprehensive feasibility PDF with clear titles, zoning info, and FSI potential.",
    icon: FileOutput
  }
];

export const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="py-24 bg-gray-50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight mb-4">
            From Data to Decision in Minutes
          </h2>
        </div>

        <div className="relative">
          {/* Animated Connector Line (Desktop) */}
          <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-0.5 bg-gray-200">
             <motion.div 
                initial={{ width: 0 }}
                whileInView={{ width: "100%" }}
                viewport={{ once: true }}
                transition={{ duration: 1.5, ease: "easeInOut" }}
                className="h-full bg-green-600"
             ></motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {steps.map((step, index) => (
              <motion.div
                key={step.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.3 }}
                className="relative flex flex-col items-center text-center group"
              >
                <div className="w-32 h-32 rounded-full bg-white border-8 border-gray-50 flex items-center justify-center mb-8 shadow-sm relative z-10 group-hover:border-green-50 transition-colors duration-300">
                    <div className="bg-white rounded-full p-4 shadow-inner">
                        <step.icon className="w-10 h-10 text-green-600" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center text-white font-bold text-sm border-4 border-white">
                        {step.id}
                    </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 max-w-xs leading-relaxed">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
